module.exports = __webpack_public_path__ + "img/alisa-yandex.9c03cebb.svg";